import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import {
  ExamReportResponse,
  ExamReportsClient,
  ExamReportStatus,
  ExamReportUpdateRequest,
} from '../../../../generated-client/generated-api-client';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SyncDataService } from '../../../../services/data-services/sync-data.service';
import { isFormModifiedDataService } from '../../../../services/data-services/navigation-data-services';
import { ErrorProcessorService } from '../../../../services/error-processor.service';
import { ConfirmModalComponent } from 'src/app/components/modals/confirm-modal/confirm-modal.component';
import { SimpleModalService } from 'ngx-simple-modal';

@Component({
  selector: 'app-exam-report-details-tab',
  templateUrl: './exam-report-details-tab.component.html',
  styleUrls: ['./exam-report-details-tab.component.sass'],
})
export class ExamReportDetailsTabComponent implements OnInit {
  id: string = '';
  response!: Observable<ExamReportResponse>;

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private client: ExamReportsClient,
    private toastr: ToastrService,
    private _modalService: SimpleModalService,
    private _syncService: SyncDataService,
    private _isFormModifiedDataService: isFormModifiedDataService,
    private errorProcessorService: ErrorProcessorService
  ) {
    route.parent?.paramMap.subscribe(next => {
      this.id = next.get('id') ?? '';
    });
    //this.titleService.setTitle('Jegyzőkönyv - adatai');
  }

  ngOnInit(): void {
    this.response = this.client.get(this.id);
    this.response.subscribe(examReport => {
      this.titleService.setTitle(examReport.identifier + '- adatai');
    });
  }

  onSubmit(form: FormGroup): void {
    const request: ExamReportUpdateRequest = {
      id: form.get('id')?.value,
      isExamStartAutomatic: form.get('isExamStartAutomatic')?.value,
      isSkipAllow: form.get('isSkipAllow')?.value,
      registerDocuments: form.get('registerDocuments')?.value,
      percentagePrecision: form.get('percentagePrecision')?.value,
      examAddressId: form.get('examAddressId')?.value === '' ? null : form.get('examAddressId')?.value,
      examEndedAtUtc: form.get('examEndedAtUtc')?.value === '' ? null : form.get('examEndedAtUtc')?.value,
      examStartedAtUtc: form.get('examStartedAtUtc')?.value === '' ? null : form.get('examStartedAtUtc')?.value,
      closedAtUtc: form.get('closedAtUtc')?.value === '' ? null : form.get('closedAtUtc')?.value,
      openedAtUtc: form.get('openedAtUtc')?.value === '' ? null : form.get('openedAtUtc')?.value,
      identifier: form.get('identifier')?.value === '' ? null : form.get('identifier')?.value,
    };

    this.response.subscribe(examReport =>{
      if(request.examStartedAtUtc != examReport.examStartedAtUtc)
        this._modalService
          .addModal(ConfirmModalComponent,
            {
              title: 'Vizsgázók kezdési időpontjának frissítése',
              message: 'Szeretné hogy a jegyzőkönyvön szereplő vizsgázók vizsgatárgy időpontjait a rendszer automatikusan módósítsa a kezdési időpontnak megfelelően?',
              cancelText: "Nem",
              confirmText: 'Igen'
            }).subscribe(result => {
              request.examDateShift = result;
              this.sendUpdate(request);
            },
            error => this.errorProcessorService.processError(error));
      else
          this.sendUpdate(request);
    });
  }

  private sendUpdate(request: ExamReportUpdateRequest){
    this.client.edit(request).subscribe(
      next => {
        this.toastr.success('Sikeres mentés');
        this._isFormModifiedDataService.isFormModified = false;
        this._syncService.afterSuccessfulOperation.next();

        this.client.isModifiable(this.id).subscribe(isModifiable => {
          this.client.status(this.id).subscribe(examReportStatus => {
            this.client.syncGet(this.id).subscribe(
              response => {
                  if (!isModifiable || (examReportStatus != ExamReportStatus.Open && response.isSyncronized)) {
                    window.location.reload();
                  }
                },
                error => this.errorProcessorService.processError(error));
              },
              error => this.errorProcessorService.processError(error))
          },
          error => this.errorProcessorService.processError(error)
        );
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
